/**
 * Privacidad, cookies y derechos ARCOP+ (Ley 21.719).
 */
export const cookieConsent = {
  ariaLabel: 'Consentimiento de cookies',
  title: 'Cookies y privacidad (Ley 21.719)',
  description:
    'Usamos cookies esenciales para el funcionamiento del sitio. Las analíticas son opcionales y nos ayudan a mejorar el servicio. Puedes cambiar tu preferencia en cualquier momento desde la política de cookies en el pie de página o en tu perfil.',
  legalNote:
    'Responsable del tratamiento: Mi Huellita Digital. Base legal: consentimiento (Ley N° 21.719). Versión de política:',
  essentialOnlyAria: 'Aceptar solo cookies esenciales',
  essentialOnly: 'Solo esenciales',
  acceptAllAria: 'Aceptar cookies esenciales y analíticas',
  acceptAll: 'Aceptar todas',
  implicitConsent:
    'Al continuar navegando sin elegir, consideramos que aceptas solo cookies esenciales.',
} as const;

export const privacyRights = {
  title: 'Tus derechos de privacidad (Ley 21.719)',
  intro:
    'Puedes ejercer tus derechos ARCOP+ (acceso, rectificación, cancelación, oposición, portabilidad y bloqueo). Política vigente:',
  contactLabel: 'Contacto:',
  exportButton: 'Descargar mis datos (JSON)',
  exporting: 'Exportando…',
  exportSuccess: 'Datos exportados correctamente',
  exportError: 'No se pudo exportar tus datos. Intenta más tarde.',
  requestTitle: 'Solicitud formal de derechos',
  requestPlaceholder: 'Describe tu solicitud (mínimo 10 caracteres)…',
  requestMinLength: 'Describe tu solicitud con al menos 10 caracteres',
  requestSuccess:
    'Solicitud registrada. Te responderemos dentro de 30 días corridos (Ley 21.719).',
  requestError: 'No se pudo enviar la solicitud',
  submit: 'Enviar solicitud',
  submitting: 'Enviando…',
} as const;
